//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: String,
    rows: Array,
    hideOldAndBetaOption:
    {
      type: Boolean,
      default: false
    },
    sortColumn: String
  },
  data () {
    return {
      showingOldAndBeta: false
    }
  },
  computed: {
    isSoftware () {
      return this.title.toLowerCase() === 'software'
    }
  }
}
